import { authApi, authApiOut, getJwtTokenFromCookie } from "./api.service";
import { useMutation, useQuery } from "@tanstack/react-query";

type LoginData = {
  email: string;
  password: string;
};

type RegisterData = {
  refCode: string;
  userName: string;
  email: string;
  password: string;
  confirmPassword: string;
};

type MetaMaskRegisterData = {
  walletAddress: string;
  signature: string;
  message: string;
  email: string;
};

type MetaMaskLoginData = {
  walletAddress: string;
  signature: string;
  message: string;
};

export const useLoginUser = () => {
  return useMutation({
    mutationFn: (userData: LoginData) => authApi.post("/local/login", userData),
  });
};

export const useRegisterUser = () => {
  return useMutation({
    mutationFn: ({ refCode, ...registerData }: RegisterData) =>
      authApi.post(`/local/register?refCode=${refCode}`, registerData),
  });
};

export const useSocialMediaLogin = () => {
  return useMutation({
    mutationFn: (provider: string) => authApi.get(`/${provider}/auth`),
  });
};

export const useLogoutUser = () => {
  return useMutation({ mutationFn: () => authApiOut.get("/local/logout") });
};

export const registerWithMetaMask = async (data: MetaMaskRegisterData) => {
  const response = await authApi.post("/meta-mask/register", data);
  return response.data;
};

export const useMetaMaskRegister = () => {
  return useMutation({
    mutationFn: (data: MetaMaskRegisterData) => registerWithMetaMask(data),
  });
};

export const loginWithMetaMask = async (data: MetaMaskLoginData) => {
  const response = await authApi.post("/meta-mask/login", data);
  return response.data;
};

export const useMetaMaskLogin = () => {
  return useMutation({
    mutationFn: (data: MetaMaskLoginData) => loginWithMetaMask(data),
  });
};

export const useGetQr = () => {
  return useQuery({
    queryKey: ["qrcode"],
    queryFn: async () => {
      const jwtToken = getJwtTokenFromCookie();
      const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};

      return authApi.get("/2fa", { headers });
    },
  });
};

export const useVerify2fa = () => {
  return useMutation({
    mutationFn: async (token: string) => {
      const jwtToken = getJwtTokenFromCookie();
      const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};
      return authApi.post("/2fa/verify", { token }, { headers });
    },
  });
};
